<template>
  <div :class="classNames">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      label-position="top"
    >
      <el-form-item label="参与课程" prop="class" label-position="left">
        <div :class="classNames + '_from_item_con'">
            <div :class="classNames + '_disabled'"></div>
            <div :class="classNames+'_add_class'">
              <el-button type="primary" @click="addClass">添加课程</el-button>
            </div>
            <p style="color:#606266">提示：一个课程只能参加一个抢购活动</p>
            <join-market v-model="joinFlag" @sure="sure"></join-market>
        </div>
      </el-form-item>
      <el-form-item v-if="ruleForm.class">
        <div :class="classNames+'_add_con'">
          <p :class="classNames+'_tit'">挂载课程</p>
          <div :class="classNames+'_add_class_info'">
            <div :class="classNames+'_add_class_left'">
              <img :src="ruleForm.class.img" alt=""/>
            </div>
            <div :class="classNames+'_add_class_center'">{{ruleForm.class.title}}</div>
            <div :class="classNames+'_add_class_right'" @click="joinFlag = true">更换课程</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="活动日期" prop="times">
        <div :class="classNames + '_from_item_con'">
          <div :class="classNames + '_disabled'" ></div>
          <!-- :disabledDate="disabledDate" -->
          <el-date-picker
            v-model="ruleForm.times"
            popper-class="market_date_picker"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="抢购价格" prop="price">
        <div :class="classNames + '_from_item_con'">
          <el-input placeholder="请输入抢购价格" v-model="ruleForm.price" @input="handleVirPuCh"/>
          <span style="color:red">提示：{{this.userInfo.active_valid_price>0?'活动价格需大于等于'+this.userInfo.active_valid_price:'活动价格需大于'+this.userInfo.active_valid_price}}元小于课程定价</span>
        </div>
      </el-form-item>
	  
	  <el-form-item label="抢购模式" prop="active_pattern">
	  	<div :class="classNames + '_from_item_con'">
	      <el-radio-group v-model="ruleForm.active_pattern">
	          <el-radio :label="item.value" v-for="item in active_list" :key="item.value">{{item.label}}
			  <el-popover
				v-if="item.value == 2"
			  	placement="top-start"
			  	trigger="hover"
			    width="400"
			  	>
			  	<span>设置虚拟抢购，抢购人数不会进行删减，固定展示设置值</span>
			  	<img slot="reference"  class="question" src="http://img-dbzd.doubaozhidao.com/20220815/eApMRxX56w3AcXjAaFFGFB38xkAQmryz1660554235278.png?x-oss-process=image/quality,q_80/format,png" alt="">
			  </el-popover></el-radio>
			  
	      </el-radio-group> 
	  	</div>
	  </el-form-item>
	  
      <el-form-item label="抢购人数" prop="person">
        <div :class="classNames + '_from_item_con'">
          <el-input
            placeholder="输入0则默认不限人数"
            v-model="ruleForm.person"
            @input="handleSort"
          />
          <!-- <p style="color:#606266" v-if="ruleForm.active_pattern == 1">提示：超过抢购人数后，按原价购买</p> -->
        </div>
      </el-form-item>
      <el-form-item v-if="ruleForm.active_pattern == 1" label="活动结束对策" prop="empty_stock_mod">
        <div :class="classNames + '_from_item_con'">
          <el-radio-group v-model="ruleForm.empty_stock_mod">
            <el-radio v-for="item in noInventoryOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
	  
	
	  
      <el-form-item>
        <div :class="[classNames + '_operat', classNames + '_from_item_con']">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button type="primary" @click="goBack">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import JoinMarket from './joinMarketList.vue'
import { limitPrice } from '@/utils/baseUrl.js'
export default {
  name: "CreateChapter",
  data() {
    return {
      classNames: "CreateChapter",
      ruleForm: {
        class: '',
        times: [],
        price: "",
        person: "",
        active_pattern: 1,
        empty_stock_mod: 1 // 库存耗尽选项（库存模式）
      },
      rules: {
        class: [
          {
            required: true,
            message: "添加课程",
            trigger: "none",
          },
        ],
        times: [
          {
            required: true,
            message: "请输入活动日期",
            trigger: "change",
          },
        ],
        price: [
          {
            validator:(rule,value,callback)=>{
              if(value ==='') {
                callback(new Error('请输入抢购价格'))
              }
              let limitPriceObj = limitPrice(value)
              console.log(this.ruleForm.class,'---',value,this.userInfo.active_valid_price)
              if(this.userInfo.active_valid_price>0){
                if(Number(value)<this.userInfo.active_valid_price || Number(value)>=Number(this.ruleForm.class.price)) {
                  callback(new Error(`抢购价格需大于等于${this.userInfo.active_valid_price}元,小于课程定价`)) 
                }
              }else{
                if(Number(value)<=this.userInfo.active_valid_price || Number(value)>=Number(this.ruleForm.class.price)) {
                  callback(new Error(`抢购价格需大于${this.userInfo.active_valid_price}元,小于课程定价`)) 
                }
              }
             
              callback()
            },
            required: true,
            // message: "抢购价格不得低于5",
            trigger: "change",
          },
        ],
        person: [
          {
            required: true,
            message: "请输入抢购人数",
            trigger: "change",
          },
        ],
        empty_stock_mod: [
          {required: true, message: ""}
        ],
        active_pattern: [
          {
            required: true,
            message: "请选择抢购模式",
            trigger: "change",
          },
        ],
      },
      joinFlag: false,
	  active_list: [
	      {
	          label: '真实抢购',
	          value: 1
	      },
	      {
	          label: '虚拟抢购',
	          value: 2
	      }
	  ],
      noInventoryOptions: [
        {label: '库存没了恢复原价', value: 1},
        {label: '库存没了显示已抢空', value: 2},
      ] // 没库存时的选项
    };
  },
  components: {
      'join-market': JoinMarket
  },
  created() {
  },
  computed: {
    ...mapState(["breadCrumbList"]),
    ...mapState('login', ['userInfo']),
    ...mapState("chapter", ["showDetailInfo", "detailSingleClass", "saveId"]),
   pickerOptions() {
   	let _minTime = 0
   	let _maxTime = 0
   	return {
   		onPick(time) {
   			_minTime = time.minDate.getTime()
   			//             if (!time.maxDate) {
   			//                 _minTime = time.minDate.getTime() // 最小时间
   			//             } else {
   			//                 _minTime =  null;
   			//             }
   			// if (time.minDate) {
   			//     _maxTime = time.maxDate.getTime() // 最小时间
   			// } else {
   			//     _minTime =  null;
   			// }
   		},
   		disabledDate(time) {
   			return (time.getTime() < Date.now() - 24 * 60 * 60 * 1000 || time.getTime() < _minTime - 30 * 24 *
   				60 * 60 * 1000) || (time.getTime() > _minTime + 30 * 24 * 60 * 60 * 1000 && _minTime)
   		},
   		selectableRange: "10:00:00 - 23:59:59"
   	}
   }
  },
  methods: {
    ...mapActions("market", ["activeAdd"]),
    async saveDraft() {
      this.$message({
        type: "success",
        message: "保存成功",
      });
    },
    handleVirPuCh() {
        this.ruleForm.price = this.ruleForm.price.replace(/[^0-9.]/g, '')
        if (this.ruleForm.price.indexOf('.') > 0) {
            this.ruleForm.price = this.ruleForm.price.slice(0, this.ruleForm.price.indexOf('.') + 3)
        }
    },
    handleSort(value) {
      this.ruleForm.person = this.ruleForm.person.replace(/[^0-9]/g, "");
    },
    sure(value) {
        this.ruleForm.class = value
    },
    addClass() {
        this.joinFlag = true
    },
    goBack() {
        this.$router.go(-1)
    },
    submitForm(formName) {
   
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
        	let params = {
                start_time: this.ruleForm.times[0],
                end_time: this.ruleForm.times[1],
                product_id: this.ruleForm.class.id,
                number: this.ruleForm.person,
                price: this.ruleForm.price,
				active_pattern: this.ruleForm.active_pattern
            }
            if(params.active_pattern==1){
              params.empty_stock_mod = this.ruleForm.empty_stock_mod
            }
            console.log(params, '...params')
        	try {
                let res = await this.activeAdd(params)
                this.$message({
        			type: 'success',
        			message: '提交成功'
        		})
                this.$router.go(-1)
                } catch (error) {
                    
                }
        } else {
        	console.log('error submit!!');
        	this.$message.closeAll()
        	this.messageOption = this.$message({
        		message: '有必填项没有填写或格式错误',
        		showClose: true,
        		duration: 0,
        		type: 'error'
        	})
        	return false;
        }
      });
    },
  },
 
  beforeDestroy() {
    if (this.messageOption) {
      this.messageOption.close();
    }
    this.messageOption = "";
  },
};
</script>
<style lang="less">
@classNames: CreateChapter;
.market_date_picker {
    .el-picker-panel__footer {
        display: flex;
        justify-content: space-between;
        padding-left: 16px;
        padding-right: 16px;
        .el-button {
            &:nth-child(2) {
                background-color: #409eff;
                border-color: #409eff;
                color: #fff;
            }
            &.is-disabled {
                background-color: #fff;
                border-color: #ebeef5;
                color: #c0c4cc;
            }
        }
    }
}
</style>
<style lang="less" scoped>
@classNames: CreateChapter;
.@{classNames} {
  max-width: 660px;
  // margin: 0 auto;
  // position: relative;
  .@{classNames}_from_item_con {
    width: 660px;
    display: inline-block;
    position: relative;
  }
}
.@{classNames}_from_item_tit {
  margin-left: 20px;
}
.@{classNames}_operat {
  display: flex !important;
  justify-content: flex-end;
}
.@{classNames}_class_content {
  .@{classNames}_radio {
    display: flex;
    flex-direction: column;
    position: relative;
    left: 20px;

    .el-radio {
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
}
.@{classNames}_add_con {
  .@{classNames}_tit {
    font-size: 14px;
    color: #37383c;
    line-height: 20px;
    margin-bottom: 10px;
    font-weight: 550;
  }
  .@{classNames}_add_class_info {
    width: 660px;
    height: 80px;
    background: #f8f9fb;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .@{classNames}_add_class_left {
      width: 60px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .@{classNames}_add_class_center {
      width: 410px;
      height: 100%;
      color: #6a6c76;
      word-break: break-all;
      line-height: normal;
    }
    .@{classNames}_add_class_right {
      font-size: 14px;
      line-height: 20px;
      color: #409eff;
      cursor: pointer;
    }
  }
}
.question {
    position: relative;
    left: 5px;
    top: 3px;
    width: 17px;
    height: 17px;
    margin-right: 10px;
}
</style>
